<template>
  <BaseDataIterator :service="fetchData">
    <template #default="dataIteratorProps">
      <div key="grid_view" class="p-4 bg-gray-100">
        <BaseGrid :columns="4" class="gap-4">
          <ChannelCard v-for="item in dataIteratorProps.data" :key="item.id" :channel="item" />
        </BaseGrid>
      </div>
    </template>
  </BaseDataIterator>
</template>

<script>
import { accountChannelsClient } from '@/api/clients';
import ChannelCard from '@/components/AccountChannels/ChannelCard.vue';

export default {
  components: {
    ChannelCard,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    since: {
      type: String,
      default: '',
    },
    until: {
      type: String,
      default: '',
    },
  },
  methods: {
    fetchData(params) {
      return accountChannelsClient
        .list(this.accountId, {
          params: {
            ...params,
            filter: {
              ...(params?.filter || {}),
              channable_type: 'ga_campaign',
              ...(this.since && this.until
                ? { created_between: [this.since, this.until].join(',') }
                : {}),
            },
            page_size: 20,
          },
        })
        .then((r) => r.data);
    },
  },
};
</script>
